<template>
  <Transition name="alert">
    <div v-if="show" :class="['alert', type]">
      <div class="alert-content">
        <div class="alert-icon">
          <i class="material-icons" :class="icon"></i>
        </div>
        <div class="alert-message">{{ message }}</div>
        <button class="close-button" @click="$emit('close')">
          <i class="material-icons fa-times"></i>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'GameAlert',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['success', 'error', 'info', 'warning'].includes(value)
    }
  },
  computed: {
    icon() {
      const icons = {
        success: 'fa-check-circle',
        error: 'fa-times-circle',
        info: 'fa-info-circle',
        warning: 'fa-exclamation-triangle'
      };
      return icons[this.type];
    }
  }
};
</script>

<style scoped>
.alert {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 300px;
  max-width: 500px;
  padding: 16px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.alert-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.alert-icon {
  display: flex;
  align-items: center;
}

.alert-message {
  flex-grow: 1;
  color: #fff;
  font-size: var(--f-3);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.close-button {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s;
}
@media (hover: hover) {
  .close-button:hover {
    color: #fff;
  }
}

.success {
  border-left: 4px solid #4caf50;
}

.error {
  border-left: 4px solid #f44336;
}

.info {
  border-left: 4px solid #2196f3;
}

.warning {
  border-left: 4px solid #ff9800;
}

.success .alert-icon { color: #4caf50; }
.error .alert-icon { color: #f44336; }
.info .alert-icon { color: #2196f3; }
.warning .alert-icon { color: #ff9800; }

.alert-enter-active,
.alert-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
}

.alert-enter-from {
  opacity: 0;
  transform: translate(-50%, -20px);
}

.alert-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>
